import clsx from 'clsx';
import React from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './AppliedFilters.module.scss';

import { FacetData } from '../../types';
import Cross from '../../kit/icons/Cross';

export interface AppliedFiltersProps
    extends React.HTMLAttributes<HTMLDivElement> {
    filters?: FacetData[];
    onRemoveFilter?: (facetName: string, value: string) => void;
    clearAllFilters?: () => void;
    mobileSidebarStyles?: boolean;
    mobileToolbarStyles?: boolean;
}

const AppliedFilters: React.FC<AppliedFiltersProps> = ({
    filters,
    onRemoveFilter,
    clearAllFilters,
    mobileSidebarStyles = false,
    mobileToolbarStyles = false
}) => {
    const st: CssModuleType = currentCssModule;

    if (!filters?.length) return;

    return (
        <div
            className={clsx(
                st['applied-filters'],
                mobileSidebarStyles ? st['mobile-sidebar'] : '',
                mobileToolbarStyles ? st['mobile-toolbar'] : ''
            )}
        >
            <ul>
                {filters.map((filter, ind) => (
                    <li key={`${filter.value}_${ind}`}>
                        <button
                            onClick={() =>
                                onRemoveFilter && onRemoveFilter(filter.facet_name, filter.value)
                            }
                        >
                            {filter.display_name}
                            <Cross size={6} />
                        </button>
                    </li>
                ))}
                <li>
                    <button
                        onClick={() => clearAllFilters && clearAllFilters()}
                    >
                        Clear all
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default AppliedFilters;
